import { useAPI, useFetchAPI } from '@/composables';
import type { IQueryParams, ReportAPI } from '@/types';
import { params2Query } from '@/utils';

const buildUrlWithToken = (baseUrl: string, token: string) => {
  return token !== '' ? `${baseUrl}/magic/link?token=${token}` : baseUrl;
};

export const getReports = (tab: string, query: IQueryParams) => {
  return useAPI<ReportAPI>(
    `/reports?filter[tab]=${tab}&${params2Query(query)}`
  );
};

export const getReportPreview = async (id: string, token: string) => {
  const baseUrl = `/reports/${id}`;
  const url = buildUrlWithToken(baseUrl, token);
  try {
    const response = await useAPI(url);
    return response;
  } catch (error: any) {
    console.log('Error caught in getReportPreview:', error);

    const errorCode = error.statusCode || null;

    if (token !== '' && errorCode === 404) {
      if (process.client) {
        window.location.href = '/vdp/login';
        // Prevent further execution
        return new Promise(() => {});
      }
    }

    throw error;
  }
};

export const getReportDetails = () => {
  return useAPI('/reports/details');
};

export const saveReport = (payload: FormData) => {
  return useFetchAPI('/reports', {
    method: 'POST',
    body: payload
  });
};

export const saveLinkToFix = (id: string, link: string, token: string) => {
  const baseUrl = `/reports/${id}/link`;
  const url = buildUrlWithToken(baseUrl, token);
  return useFetchAPI(url, {
    method: 'PUT',
    body: { link }
  });
};

export const uploadFixedCode = (
  id: string,
  payload: FormData,
  token: string
) => {
  const baseUrl = `/reports/${id}/upload`;
  const url = buildUrlWithToken(baseUrl, token);
  return useFetchAPI(url, {
    method: 'POST',
    body: payload
  });
};

export const getReportChat = (uuid: string, token: string) => {
  const baseUrl = `/reports/${uuid}/messages`;
  const url = buildUrlWithToken(baseUrl, token);
  return useAPI(url);
};

export const saveChatMessage = (
  uuid: string,
  payload: FormData,
  token: string
) => {
  const baseUrl = `/reports/${uuid}/messages`;
  const url = buildUrlWithToken(baseUrl, token);
  return useFetchAPI(url, {
    method: 'POST',
    body: payload
  });
};

export const getChatMessageRead = (uuid: string, token: string) => {
  const baseUrl = `/reports/${uuid}/message`;
  const url =
    token !== ''
      ? `${baseUrl}/magic/link/read?token=${token}`
      : `${baseUrl}/read`;
  return useFetchAPI(url, {
    method: 'POST'
  });
};
